import Big from 'big.js';
import * as lineitems from 'smg/customer-api/lineitems';
import { DollarFormat } from 'smg/util';

const $optionPricing = document.querySelectorAll<HTMLElement>('.child-line-item-option-price,.child-line-item-price');
$optionPricing.forEach(async $optionPricing => {
    const lineItem = $optionPricing.getAttribute('data-line-item');
    const child = $optionPricing.getAttribute('data-child');
    const option = $optionPricing.getAttribute('data-option');
    const free = $optionPricing.getAttribute('data-free');
    const template = $optionPricing.getAttribute('data-template');
    if (!lineItem || !(child || option)) {
        return;
    }

    let price: Big = Big(0);

    if (child && (!option || !$optionPricing.matches('.child-line-item-option-price'))) {
        price = await lineitems.GetChildPrice(lineItem, child);
    } else if (child && option) {
        price = await lineitems.GetOptionPrice(lineItem, child, option);
    }

    if ($optionPricing.hasAttribute('data-free') && Big(price).eq(0)) {
        $optionPricing.textContent = free;
        return;
    }

    if (template) {
        $optionPricing.textContent = template.replace('$', DollarFormat(price));
    } else {
        $optionPricing.textContent = DollarFormat(price);
    }

    $optionPricing.setAttribute('data-price', price.toString());
});
